export const RHF_SEARCH_PUBLICATION_CONSTS = {
  add: 'Добавить',
  incorrectLink: 'Неверная ссылка',
  publicationLink: 'Ссылка на публикацию',
  publicationRegexp1: /https?\:\/\/.*ura\.?news\/(news|articles)\/\d{1,10}\/?/,
  publicationRegexp2: /https?\:\/\/.*ura\.?news\/(news|articles)\//
}
